<template>
  <div class="alpha-nav-container">
    <div ref="alphaNav" class="alpha-nav">
      <a href="#" @click.prevent="jumpToLetter('abcd')">A-D</a>
      <a href="#" @click.prevent="jumpToLetter('efgh')">E-H</a>
      <a href="#" @click.prevent="jumpToLetter('ijkl')">I-L</a>
      <a href="#" @click.prevent="jumpToLetter('mnop')">M-P</a>
      <a href="#" @click.prevent="jumpToLetter('qrst')">Q-T</a>
      <a href="#" @click.prevent="jumpToLetter('uvwx')">U-X</a>
      <a href="#" @click.prevent="jumpToLetter('yz')">Y-Z</a>

      <div ref="btt" class="btt">
        <a href="#" @click.prevent="backToTop"><i class="far fa-fw fa-arrow-alt-circle-up"></i></a>
        <a href="#" @click.prevent="jumpToLetter('abcd')">A-D</a>
        <a href="#" @click.prevent="jumpToLetter('efgh')">E-H</a>
        <a href="#" @click.prevent="jumpToLetter('ijkl')">I-L</a>
        <a href="#" @click.prevent="jumpToLetter('mnop')">M-P</a>
        <a href="#" @click.prevent="jumpToLetter('qrst')">Q-T</a>
        <a href="#" @click.prevent="jumpToLetter('uvwx')">U-X</a>
        <a href="#" @click.prevent="jumpToLetter('yz')">Y-Z</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'alphanav',
  data() {
    return {
      obs: null,
    }
  },
  computed: {
    isHome() {
      return this.$route.fullPath == '/'
    },
  },
  methods: {
    backToTop() {
      window.scrollTo(0, 0)
    },
    jumpToLetter(set) {
      let letters = set.split('')
      
      for (let l of letters) {
        let target = document.querySelector(`[data-letter="${l}"]`)

        if (target) {
          target.scrollIntoView()
          break;
        }
      }
    },
  },
  mounted() {

    this.$nextTick(() => {
      this.obs = new IntersectionObserver((entries) => {
        this.$refs.btt.classList.toggle('visible', !entries[0].isIntersecting)
      }, {rootMargin: '20px 0px 0px 0px'});

      this.obs.observe(this.$refs.alphaNav);
    })
  },
  beforeUnmount() {
    this.obs.unobserve(this.$refs.alphaNav)
  },
}
</script>
<style lang="scss">
.alpha-nav-container {
  .alpha-nav {
    margin: 10px 0;
    text-align: center;

    a {
      margin: 0 8px;
    }

  }
  .btt {
    background: white;
    padding: 1rem;
    position: fixed;
    right: calc(5vw - 15px);
    bottom: 0;
    transition: 300ms transform ease;
    transform: translateY(100%);

    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.5);

    &.visible {
      bottom: 0;
      transform: translateY(0%)
    }
  }
}
</style>
